<div class="parenting">
  <span *ngIf="data" [appBageStatusStyle]="data.status">
    {{ data.status | translate }}
  </span>
</div>
